// @flow

export const loadScript = (url: string, scriptId: string): Promise<any> =>
  new Promise(resolve => {
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = url;
      script.async = true;
      if (!document.body) {
        throw Error('document.body does not exist');
      }
      document.body.appendChild(script);
    }
    script.addEventListener('load', () => resolve(script));
  });



// WEBPACK FOOTER //
// ../utilities/script.js